import { Component, OnInit } from '@angular/core';
import { SliderStepComponent } from '../../step/slider-step/slider-step.component';
import { ControlContainer, FormGroupDirective, UntypedFormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-new-home-value',
  templateUrl: './new-home-value.component.html',
  styleUrls: ['./new-home-value.component.scss', '../../step/step.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class NewHomeValueComponent extends SliderStepComponent implements OnInit {
  public enterFieldValue: number;
  public title: string = "Purchase price of new home";

  ngOnInit() {
    this.sliderValues = [60000, 70000, 80000, 90000, 100000, 110000, 120000, 130000, 140000, 150000, 160000, 170000,
      180000, 190000, 200000, 220000, 240000, 260000, 280000, 300000, 325000, 350000, 375000, 400000, 425000, 450000, 475000, 500000,
      525000, 550000, 575000, 600000, 625000, 650000, 675000, 700000, 725000, 750000, 775000, 800000, 850000, 900000, 950000, 1000000,
      1250000, 1500000, 1750000, 2000000, 2500000, 3000000, 3000000];

    this.sliderLabels = ['Under $60,000', '$60,001 - $70,000', '$70,001 - $80,000',
      '$80,001 - $90,000', '$90,001 - $100,000', '$100,001 - $110,000', '$110,001 - $120,000', '$120,001 - $130,000', '$130,001 - $140,000',
      '$140,001 - $150,000', '$150,001 - $160,000', '$160,001 - $170,000', '$170,001 - $180,000', '$180,001 - $190,000', '$190,001 - $200,000',
      '$200,001 - $220,000', '$220,001 - $240,000', '$240,001 - $260,000', '$260,001 - $280,000', '$280,001 - $300,000', '$300,001 - $325,000',
      '$325,001 - $350,000', '$350,001 - $375,000', '$375,001 - $400,000', '$400,001 - $425,000', '$425,001 - $450,000', '$450,001 - $475,000',
      '$475,001 - $500,000', '$500,001 - $525,000', '$525,001 - $550,000', '$550,001 - $575,000', '$575,001 - $600,000', '$600,001 - $625,000',
      '$625,001 - $650,000', '$650,001 - $675,000', '$675,001 - $700,000', '$700,001 - $725,000', '$725,001 - $750,000', '$750,001 - $775,000',
      '$775,001 - $800,000', '$800,001 - $850,000', '$850,001 - $900,000', '$900,001 - $950,000', '$950,001 - $1,000,000',
      '$1,000,001 - $1,250,000', '$1,250,001 - $1,500,000', '$1,500,001 - $1,750,000', '$1,750,001 - $2,000,000', '$2,000,001 - $2,500,000',
      '$2,500,000 - $3,000,000', '$3,000,000 or more'];

    this.sliderValue = 15;
    this.sliderDisplay = this.sliderLabels[this.sliderValue];

    this.control = new UntypedFormControl('', Validators.required);
    this.form.addControl('newHomeValue', this.control);
  }

  slide(e) {
    this.sliderValue = e.target.value;
    this.sliderDisplay = this.sliderLabels[e.target.value];

    if (this.sliderDisplay === 'Under $60,000') {
      this.enterFieldValue = null;
    } else {
      this.enterFieldValue = this.sliderValues[this.sliderValue];
    }
    this.enterHomeValue = this.enterFieldValue;

    //add commas to numeric inputs
    this.enterStringFieldValue = this.enterFieldValue?.toLocaleString();
  }

  setSlide(e) {

    let value = parseFloat(e.target.value.replace(/,/g, ''));
    this.enterFieldValue = isNaN(value) ? 0 : value;

    //add commas to numeric inputs
    this.enterStringFieldValue = this.enterFieldValue?.toLocaleString();

    if (this.enterFieldValue <= 200000) {
      var diff = 10000;
    } else if (this.enterFieldValue <= 300000) {
      var diff = 20000;
    } else if (this.enterFieldValue <= 800000) {
      var diff = 25000;
    } else if (this.enterFieldValue <= 1000000) {
      var diff = 50000;
    } else if (this.enterFieldValue <= 2000000) {
      var diff = 250000;
    } else {
      var diff = 500000;
    }

    if (this.enterFieldValue <= 60000 && this.enterFieldValue > 50000) {
      this.sliderValue = 3;
    } else if (this.enterFieldValue <= 50000 && this.enterFieldValue > 40000) {
      this.sliderValue = 2;
    } else if (this.enterFieldValue == 40000) {
      this.sliderValue = 1;
    } else if (this.enterFieldValue < 40000) {
      this.sliderValue = 0;
    } else if (this.enterFieldValue > 2500000 && this.enterFieldValue < 3000000) {
      this.sliderValue = 52;
    } else {
      for(var i = 3; i < this.sliderValues.length; i++) {
        if ((this.sliderValues[i] - diff) < this.enterFieldValue && (this.sliderValues[i + 1] == undefined || (this.sliderValues[i + 1] - diff) >= this.enterFieldValue)) {
          this.sliderValue = i;
          break;
        }
      }
    }

    //probably we need to use this.enterFieldValue and move it on parent class level
    this.enterHomeValue = this.enterFieldValue; 
    this.sliderDisplay = this.sliderLabels[this.sliderValue];
  }

  countVisitorAction() {
    this.form.controls.newHomeValueAction.setValue('1');
  }
}
